// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Unterhaltung',
  working: 'Ich denke nach…',
  stopped: 'Gestoppt. Es wurde nichts geändert.',
  step_stopped: 'Gestoppt',
  steps_completed_one: '{{count}} Schritt erledigt',
  steps_completed_other: '{{count}} Schritte erledigt',
  chart: {
    table: 'Die Zahlen in diesem Diagramm',
    label: 'Bezeichnung',
    value: 'Wert',
  },
  // A form of several values Amigo needs at once (ask_form, contracts §5).
  form: {
    submit: 'Weiter',
    skip: 'Später',
    required: 'Bitte ausfüllen, um weiterzumachen',
    generated: 'Wird beim Freigeben für dich erstellt',
    step_of: 'Schritt {{index}} von {{total}}',
    on: 'An',
    off: 'Aus',
    skipped: 'Für später aufgehoben',
  },
  next_steps: 'Nächste Schritte',
  action_card: {
    select_restaurant: 'Dieses Restaurant auswählen',
    open_page: 'Öffnet im Dashboard',
  },
  not_sent: 'Nicht gesendet',
  failed: {
    text: 'Bei mir ist etwas schiefgelaufen, es wurde nichts geändert. Versuch es gleich noch mal.',
    retry: 'Erneut versuchen',
  },
  question: {
    other: 'Etwas anderes…',
    send: 'Senden',
    label: 'Frage',
    type_answer: 'Etwas anderes? Schreib es unten.',
    label_many: 'Fragen',
    step_of: '{{index}} von {{total}}',
    previous: 'Vorherige Frage',
    next: 'Nächste Frage',
    dismiss: 'Jetzt nicht',
  },
  unavailable: {
    title: {
      amigo: 'Amigo ist gerade nicht verfügbar.',
      assistant: 'Der Assistent ist gerade nicht verfügbar.',
    },
    text: 'Es wurde nichts geändert, und der Rest des Dashboards funktioniert wie gewohnt. Versuch es in ein paar Minuten noch mal.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Heute',
  when: {
    today: 'Heute, {{time}}',
    yesterday: 'Gestern, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Neuer Chat für {{restaurant}}. Die Chats von {{previous}} findest du unter Chats, wenn du zurückwechselst.',
  // A restaurant selected during a chat with no restaurant selected (D18): the chat carries on there, or a new one starts.
  carried_on_line: 'Jetzt bei {{restaurant}}. Dieser Chat geht weiter und wird bei seinen Chats gespeichert.',
  from_none_line:
    'Neuer Chat für {{restaurant}}. Deinen Chat zu {{earlier}} findest du unter Chats, ohne ausgewähltes Restaurant.',
  from_none_line_unnamed:
    'Neuer Chat für {{restaurant}}. Deinen vorherigen Chat findest du unter Chats, ohne ausgewähltes Restaurant.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat von {{name}} (FoodAmigos)',
      owner: 'Chat von {{name}} (Inhaber)',
      staff: 'Chat von {{name}} (Mitarbeiter)',
      partner: 'Chat von {{name}} (Partner)',
      other: 'Chat von {{name}}',
      unnamed: 'Chat von jemand anderem',
    },
    text: 'Chat von {{name}}. Du kannst ihn lesen, aber nicht antworten oder seine Karten freigeben.',
    text_unnamed: 'Chat von jemand anderem. Du kannst ihn lesen, aber nicht antworten oder seine Karten freigeben.',
    new_chat: 'Neuer Chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Dieser Chat ist beendet. Starte einen neuen Chat, um weiterzumachen.',
    new_chat: 'Neuer Chat',
    moved_line: 'Neuer Chat, weil der vorige beendet war',
  },
  composer: {
    label: 'Nachricht',
    placeholder: 'Stell eine Frage oder beschreib eine Änderung',
    placeholder_answer: 'Schreib deine Antwort',
    hint: 'Enter zum Senden · Shift+Enter für eine neue Zeile',
  },
  table: {
    show_all: 'Alle {{count}} Zeilen zeigen',
    show_fewer: 'Weniger zeigen',
  },
  steps: {
    areas: 'Ich schaue, wobei ich hier helfen kann',
    area_describe: 'Ich sehe mir {{area}} an',
    restaurants: 'Ich suche das Restaurant',
    read: 'Ich lese deine Daten',
    propose: 'Ich bereite die Änderung vor',
    change_set_get: 'Ich prüfe die Änderung',
    change_set_undo: 'Ich bereite das Rückgängigmachen vor',
    change_set_withdraw: 'Ich schließe die Karte',
    gap_record: 'Ich notiere das für unser Team',
    research: 'Ich schaue nach, wie das funktioniert',
    screen_find: 'Ich suche die richtige Seite',
    file_read: 'Ich lese deine Datei',
    attach_chat_file: 'Ich bereite deine Datei vor',
    shop_check: 'Ich prüfe deinen Shop',
    area_describe_other: 'Ich sehe mir diesen Bereich an',
    other: 'Ich prüfe etwas',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    restaurants: {
      other: 'Ich konnte das Restaurant nicht finden',
    },
    read: {
      menu: 'Ich konnte die Speisekarte nicht lesen',
      hours: 'Ich konnte die Öffnungszeiten nicht lesen',
      order_settings: 'Ich konnte die Bestelleinstellungen nicht lesen',
      my_info: 'Ich konnte deine Angaben nicht lesen',
      marketing: 'Ich konnte dein Marketing nicht lesen',
      gift_cards: 'Ich konnte die Geschenkkarten nicht lesen',
      reports: 'Ich konnte deine Zahlen nicht lesen',
      other: 'Ich konnte deine Daten nicht lesen',
    },
    propose: {
      menu: 'Ich konnte die Änderung der Speisekarte nicht vorbereiten',
      hours: 'Ich konnte die Änderung der Öffnungszeiten nicht vorbereiten',
      order_settings: 'Ich konnte die Änderung der Bestelleinstellungen nicht vorbereiten',
      my_info: 'Ich konnte die Änderung deiner Angaben nicht vorbereiten',
      marketing: 'Ich konnte die Marketing-Änderung nicht vorbereiten',
      gift_cards: 'Ich konnte die Änderung der Geschenkkarten nicht vorbereiten',
      other: 'Ich konnte die Änderung nicht vorbereiten',
    },
    change_set_get: { other: 'Ich konnte die Änderung nicht prüfen' },
    change_set_undo: { other: 'Ich konnte das Rückgängigmachen nicht vorbereiten' },
    change_set_withdraw: { other: 'Ich konnte die Karte nicht schließen' },
    research: { other: 'Ich konnte nicht nachschauen, wie das funktioniert' },
    screen_find: { other: 'Ich konnte die Seite nicht finden' },
    file_read: { other: 'Ich konnte deine Datei nicht lesen' },
    attach_chat_file: { other: 'Ich konnte deine Datei nicht vorbereiten' },
    shop_check: { other: 'Ich konnte deinen Shop nicht öffnen' },
  },
  // The areas of contracts §0 as the steps name them ("Ich sehe mir {{area}} an").
  areas: {
    menu: 'die Speisekarte',
    hours: 'die Öffnungszeiten',
    order_settings: 'die Bestelleinstellungen',
    my_info: 'deine Restaurantinfos',
    marketing: 'das Marketing',
    reports: 'die Berichte',
  },
};
